(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["brand-usps"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function(){
    if(document.querySelectorAll('.ashba-brand__block').length > 0){
        const blocks = document.querySelectorAll('.ashba-brand__block');
        let currentIndex = 0;

        setInterval(() => {
            if (currentIndex === blocks.length) {
                blocks.forEach(block => block.classList.remove('show'));
                currentIndex = 0;
                return;
            }

            blocks[currentIndex].classList.add('show');
            currentIndex++;
        }, 1000);
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', () => {
  const sliders = document.querySelectorAll('.sliding-footer-images .group-block-content');

  sliders.forEach((slider) => {
    const items = Array.from(slider.querySelectorAll('.image-block'));
    if (items.length <= 1) return;

    let index = 0;

    items.forEach((item, i) => {
      item.style.display = i === 0 ? 'block' : 'none';
    });

    setInterval(() => {
      items[index].style.display = 'none';

      index = (index + 1) % items.length;

      items[index].style.display = 'block';
    }, 800);
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ingredients-section"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function() {
    if(document.querySelectorAll('.alphabet-tab').length > 0){
      const tabs = document.querySelectorAll('.alphabet-tab');
      tabs.forEach(tab => {
            tab.addEventListener('click', function() {
                tabs.forEach(t => {
                    t.classList.remove('active');
                });
                this.classList.add('active');
                const section = document.querySelector(tab.getAttribute('data-target'));
                if (section){
                  let scrollDiv = section.offsetTop - 100;
                  window.scrollTo({ top: scrollDiv, behavior: 'smooth'});
                } 
            });
      });
    } 

    if(document.querySelectorAll('.dictionary-entry-card').length > 0){
        const cards = document.querySelectorAll('.dictionary-entry-card');
        cards.forEach(card => {
            card.addEventListener('click', function() {
                let modalContent = card.querySelector('.dictionary-entry-card-info-content').innerHTML;
                document.querySelector('.dictionary-entry-card-modal .dictionary-entry-card-modal-content').innerHTML = modalContent;
                document.querySelector('.dictionary-entry-card-modal').style.display = 'block';
            });
        });
    }

    if(document.querySelector('.dictionary-entry-card-modal-close')){
        document.querySelector('.dictionary-entry-card-modal-close').addEventListener('click', function() {
            document.querySelector('.dictionary-entry-card-modal .dictionary-entry-card-modal-content').innerHTML = '';
            document.querySelector('.dictionary-entry-card-modal').style.display = 'none';
        });
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-blog"]) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function(){
    if(document.querySelector('.view_more_btn')){
      document.querySelector('.view_more_btn').onclick = function(){
        document.querySelector('.blog-posts').classList.add('show-all');
        document.querySelector('.view_more_btn').style.display = 'none';
      }
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["shoppable-video-embed"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('.ashba-shoppable-video__sound_buttons').forEach(function(elem){
      elem.onclick = function(event){
        event.preventDefault();
        let card = elem.closest('.ashba-shoppable-video__card');
        let cardParent = card.closest('.ashba-shoppable-video');
        let videoElement = card.getElementsByTagName('video')[0];
        if(card.classList.contains('sound-on')){
            videoElement.muted = true;
        }
        else{
            if(cardParent.querySelector('.ashba-shoppable-video__card.sound-on')){
                cardParent.querySelector('.ashba-shoppable-video__card.sound-on').querySelector('video').muted = true;
                cardParent.querySelector('.ashba-shoppable-video__card.sound-on').classList.remove('sound-on');
            }
            videoElement.muted = false;
        }
        elem.closest('.ashba-shoppable-video__card').classList.toggle('sound-on');
      }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tabs"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function() {
    if(document.querySelectorAll('button.ashba-tabs__tab').length > 0){
      const tabs = document.querySelectorAll('button.ashba-tabs__tab');
      tabs.forEach(tab => {
            tab.addEventListener('click', function() {
                // .is-active and aria-selected, the names the markup and CSS use. This
                // toggled 'active', which nothing styles, so the first tab stayed lit.
                tabs.forEach(t => {
                    t.classList.remove('is-active');
                    t.setAttribute('aria-selected', 'false');
                });
                this.classList.add('is-active');
                this.setAttribute('aria-selected', 'true');
                const section = document.querySelector(tab.getAttribute('data-href'));
                if (section){
                  let scrollDiv = section.offsetTop - 150;
                  window.scrollTo({ top: scrollDiv, behavior: 'smooth'});
                } 
            });
      });
    } 
  });

  } catch(e) { console.error(e); }
})();
})();
